import React, {useEffect, useState} from 'react'
import {Col, Row} from 'react-bootstrap'

import Box from '../component/Box/Box'
import Page from '../component/Page/Page'
import BreadcrumbItem from '../component/BreadcrumbItem/BreadcrumbItem'
import NodeSelector, {mapItems} from "../gateways/component/NodeSelector";
import {DateRangeSelector} from "../component/Date/DateRangeSelector";
import {dayMonthYearAtTime, getDaysAgo, todayLastTime} from "../utils/dates";
import HttpRequest from "../services/HttpRequest";
import LoadingV2 from "../component/Loading/LoadingV2";
import {InputWithLabel} from "../component/Form/InputWithLabel";
import {Line} from "react-chartjs-2";

function NodeSensingScreen({match, history}) {

  const http = new HttpRequest();
  const [node, setNode] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [chartData, setChartData] = useState(true);

  const [customFilter, setCustomFilter] = useState(
    {
      startDate: getDaysAgo(1),
      endDate: todayLastTime()
    })
  const breadcrumbs = [
    <BreadcrumbItem key={1} title="Lista de Nodes" to="/list/nodes"/>,
    <BreadcrumbItem key={2} title="Leituras dos Nodes"/>
  ]

  const loadNodeById = async (nodeId) => {
    const data = await http.get(`/cloud/v1/nodes/${nodeId}`);
    loadNodeSensing(data, null, customFilter);
  }
  useEffect(() => {
    loadNodeById(match.params.nodeId);
  }, [match.params.nodeId]);

  const loadNodeSensing = async (node, epc, _customFilter = customFilter) => {
    setIsLoading(true);
    !epc && setNode(mapItems(node) || node);
    if (!node) {
      setIsLoading(false);
    }
    const data = await http.get(
      `/cloud/v1/sensings/nodes/${node.id}/summary?startDate=${_customFilter.startDate.toISOString()}&endDate=${_customFilter.endDate.toISOString()}&epcValue=${epc
      || ''}`);
    console.log('data', data)
    setIsLoading(false);

    const cData = {
      datasets: [],
      labels: []
    };

    data.forEach(x => {
      const {data} = x;
      data.map(y => {
        y.whenFormated = dayMonthYearAtTime(y.when);
        cData.labels.push(y.whenFormated)
      });
    });

    cData.labels = cData.labels.sort();

    data.forEach((x, i) => {
      const {data, value} = x;
      const color = intToRGB(
          parseInt(
              (parseInt(value, 16) + '').substr(-2) * i
          )
      );

      cData.datasets.push({
        label: value,
        data: cData.labels.map(l => {
          const objt = data.find(d => d.whenFormated === l);
          if (objt) {
            return objt.rssi;
          }
          return null;
        }),
        borderColor: 'rgb(' + color.blue + ', ' + color.green + ', ' + color.red
          + ')',
        backgroundColor: 'rgb(' + color.blue + ', ' + color.green + ', '
          + color.red + ', 0.5)',
        borderWidth: 2,
        spanGaps: true,
        fill: false,
      });

    });

    setChartData(cData)

  }

  const intToRGB = function (value) {
    var blue = Math.floor(value % 256);
    var green = Math.floor(value / 256 % 256);
    var red = Math.floor(value / 256 / 256 % 256);

    return {blue, green, red};
  }

  const handleDateRangeSelect = (startDate, endDate) => {
    const customFilter = {startDate, endDate};
    setCustomFilter(customFilter);
    loadNodeSensing(node, null, customFilter)
  }

  return (
      <Page title="Leituras do Node" breadcrumbs={breadcrumbs}>
        <Box title="Selecione o ponto de Leitura">
          <Row>
            <Col sm={4}>
              <InputWithLabel inputType="text"
                              className="form-control"
                              placeholder="3035xxxxx"
                              name="epcValue"
                              label="EPC"
                              onChangeWithDelay={text => {
                                loadNodeSensing(node, text, customFilter)
                              }}
              />
            </Col>
            <Col sm={4}>
              <NodeSelector defaultValue={node} onChange={loadNodeSensing}/>
            </Col>
            <Col sm={4}>
              <DateRangeSelector defaultStartDate={customFilter.startDate}
                                 onChange={handleDateRangeSelect}/>
            </Col>
          </Row>
          {/*  <Form onSubmit={executeInventory}>*/}
          {/*    <InputWithLabel*/}
          {/*        className="mt-3 mb-3"*/}
          {/*        inputType="file"*/}
          {/*        required*/}
          {/*        onChange={onSelectFile}*/}
          {/*    />*/}
          {/*    <FormButtons history={history} isLoading={isLoading}/>*/}
          {/*  </Form>*/}
        </Box>
        <Box title="Dados de Leitura">

          {isLoading ? <LoadingV2 message="Carregando dados..."/> :
              <Line
                  data={{
                    labels: chartData.labels,
                    datasets: chartData.datasets,
                  }}
                  height={400}
                  width={600}
                  options={{
                    responsive: true,
                    plugins: {
                      legend: {
                        position: 'top',
                      },
                      title: {
                        display: true,
                        text: 'Chart.js Line Chart',
                      },
                    }
                  }}
              />

          }

        </Box>
      </Page>
  )
}

export default NodeSensingScreen



// WEBPACK FOOTER //
// ./src/sensing/NodeSensingScreen.js